import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";

export const getAllInquiry = createAsyncThunk(
  "Inquiry/FindAllInquiry",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Inquiry/FindAllInquiry`,
        formdata
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
